import Axios from "axios";
import { Partner } from "dataTypes/partners";
import { ApiEndpoints, stringifyParams } from "utilities/apiService";
import AppConfig from "utilities/appConfig";

export const getPartnerBranding = (url: string) =>
  Axios.get<Partner>(AppConfig.ApiURL() + ApiEndpoints.PartnerBrandingByUrl + stringifyParams({ url }));
